import { OverlayManager } from './index';

/**
 * Generates markup for deprecation of the generation one chromecast devices.
 * @returns Markup.
 */
export const gen1Deprecated = () => {
  const overlay = OverlayManager.createOverlayElement(
    'overlay',
    'bg-midnight font-tv2 opacity-100 flex justify-center items-center text-white flex-col absolute bottom-0 left-0 right-0 top-0 transition-opacity duration-200 enabled'
  );

  overlay.innerHTML = `
    <div class="absolute bg-no-repeat bg-contain bg-top top-0 left-0 h-[calc((64_/_1920)_*_100vw)] w-[calc((129_/_1920)_*_100vw)] m-[calc((80_/_1920)_*_100vw)] bg-tv2-logo"></div>
    <div class="z-[1] w-[41.5vw]">
      <h1 class="font-bold text-[1.875vw] leading-[120%] mb-[1.25vw] m-[2.5vw]">Chromecast generation 1 kan ikke længere benyttes</h1>
      <p class="text-[1.46vw] leading-[140%] m-[2.5vw] mt-0">
        Det er ikke længere muligt at benytte Chromecast generation 1, da vi, grundet tekniske udfordringer og begrænsninger, ikke kan levere en optimal oplevelse.<br /><br />
        Du kan stadig se TV 2 Play på mange forskellige enheder. Du kan helt uændret se TV 2 Play på din mobil, tablet og computer eller via Apple TV og Chromecast generation 2 eller nyere.<br />
        Læs mere om anbefalede enheder på play.tv2.dk/about/devices
      </p>
    </div>
  `;
  return overlay;
};
